import config from './config';

export enum APIS {
  registration = 'registration',
}

interface AmplifyConfig {
  Auth: {
    region: string
    userPoolId: string
    identityPoolId?: string
    userPoolWebClientId: string
    cookieStorage?: {
      domain?: string
      secure: boolean
      sameSite?: 'strict' | 'lax' | 'none',
    }
    authenticationFlowType?: string
  }
  API: {
    endpoints: [
      {
        name: APIS
        endpoint?: string
        region?: string
        custom_header?: Function
      }
    ]
  }
}

const amplifyConfig: AmplifyConfig = {
  Auth: {
    region: config.cognitoAWSRegion,
    userPoolId: config.cognitoAWSUserPoolID,
    userPoolWebClientId: config.cognitoAWSAppClientID,
    cookieStorage: {
      domain: config.cognitoAWSCookieDomain,
      secure: true,
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  API: {
    endpoints: [
      {
        name: APIS.registration,
        endpoint: config.registrationAPIURL,
        region: config.registrationAPIRegion,
        custom_header: () => ({
          'Content-Type': 'application/json',
        }),
      },
    ],
  },
};

export default amplifyConfig;
